<template>
  <div>
    <h2 style="padding-top: 60px;">Our Partner Dealerships</h2>
  <div class="row" style="padding-left: 0px; padding-right: 0px; padding-top: 60px; margin-left: 0px; margin-right: 0px;">
    <div class="col-lg-8 col-12" style="padding-right: 0px; padding-left: 0px;">
    <gmap-map
      :zoom="10"
      :center="center"
      style="height: 600px"
      ref="mapRef"
      :options="mapOptions"
    >
    </gmap-map>
    </div>
    
    <div class="col-12 col-lg-4" style="height: 600px; overflow-y: scroll; background-color: white; text-align: left; padding: 20px;">
      <div @click="locationMarked(i)" v-for="(loc,i) in locationMarkers" :key="loc.number">
        <h5><b :style="'text-transform: capitalize; ' + (i == selectedIndex ? 'color: #dc4225' : 'color: black')">{{loc.title}}</b><i style="margin-left: 5px; cursor: pointer" @click="openLoc(loc.map)" v-b-tooltip.hover title="Open in Google Maps" class="fas fa-map-marker-alt"></i></h5>
        <h6 style="text-transform: capitalize">{{loc.address}}</h6>
        <h6>{{loc.number}}</h6>
        <hr/>
      </div>
    </div>
  </div>
  </div>
</template>
 
<script>
import { gmapApi } from "vue2-google-maps";

export default {
  name: "AddGoogleMap",
  computed: {
    google: gmapApi,
  },

  data() {
    return {
      center: {
        lat: 31.5151367,
        lng: 74.3247457,
      },
      locationMarkers: [
        {
          position: { lat: 31.5538177, lng: 74.3200394 },
          title: "Queen's Motor",
          map: 'https://goo.gl/maps/MhQSRiqP9P8QRA4G8',
          address: "19-A Queens Road, Gate No. 4, near Sir Ganga Ram Hospital, Lahore, Pakistan",
          number: "0423-6301080, 0322-7333337/0335-4677755",
        },
        {
          position: { lat: 31.4610496, lng: 74.0815386 },
          title: "Hashmi & Hashmi",
          map: 'https://goo.gl/maps/Bact6Q4xBt2gC5Fo6',
          address:
            "Barki Rd, near Paragon City, Block J Park View CHS, Lahore, Pakistan",
          number: "042-37167020, 0316-8462484/0321-4122266",
        },
        {
          position: { lat: 31.4611259, lng: 74.2172469 },
          title: "Central Motors",
          map: 'https://goo.gl/maps/u77ApGVzjjRhKjAfA',
          address: "Multan Rd, near Eden Value Homes, opposite Honda Gateway, Eden Value Homes, Lahore, Pakistan",
          number: "0336 4614113",
        },
        {
          position: { lat: 24.8352361, lng: 67.0691561 },
          title: "Automotive Technologies",
          map: 'https://goo.gl/maps/1mrC4zL4pVhoLWZ98',
          address: "Emarah Suites, Plot No AA/B-8,Block-A, Ground Floor, S.M.C.H 3, Opposite FTC Sharah-E-Faisal, Karachi.",
          number: "0333-0308063/0333-2870698/0321-8291533",
        },
        {
          position: { lat: 33.7115742, lng: 73.0582787 },
          title: "Islamabad Motors",
          map: 'https://g.page/havalisb?share',
          address: "Lower Ground Floor, Moscow Plaza, Block H Blue Area, Islamabad, Pakistan",
          number: "0316-6095302",
        },
        {
          position: { lat: 33.557991, lng: 73.0881357 },
          title: "Rawalpindi Motors",
          map: 'https://g.page/HavalRwp?share',
          address:
            "Main Grand Trunk Rd, opposite Al-Shifa Eye Hospital, Kotha Kalan Morgah, Rawalpindi, Pakistan",
          number: "051-8896872, 0335-5647896/0300-8666886",
        },
        {
          position: { lat: 30.2322591, lng: 71.5605399 },
          title: "Southern Motors",
          map: 'https://goo.gl/maps/tTD1zvQVbYc4z7KU6',
          address: "Main khanewal road, near NLC bypass chowk, Multan, Punjab",
          number: "0336-6324000/0306-7559500",
        },
        {
          position: { lat: 32.5863228, lng: 74.053223 },
          title: "Kaira Motors",
          map: 'https://goo.gl/maps/3dTpo6aGgpK8kA9t7',
          address: "Grand Trunk Rd, opposite Pace Shopping Mall Near, Servis Industries Gujrat, Pakistan",
          number: "053-3724588, 0317-7871244/0301-8720730/0321-8403030",
        },
        {
          position: { lat: 32.4440147, lng: 74.492393 },
          title: "Sialkot Motors",
          map: 'https://goo.gl/maps/VVfHmUbfGqB3bEeb7',
          address: "Eureka Industries, 9th Km Daska Road Sialkot",
          number: "0315-2057777",
        },
      ],
      locPlaces: [],
      infowindow: [],
      markers: [],
      selectedIndex: 0,
      existingPlace: null,
      mapOptions: {
        styles: [
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [
              {
                color: "#e9e9e9",
              },
              {
                lightness: 17,
              },
            ],
          },
          {
            featureType: "landscape",
            elementType: "geometry",
            stylers: [
              {
                color: "#f5f5f5",
              },
              {
                lightness: 20,
              },
            ],
          },
          {
            featureType: "road.highway",
            elementType: "geometry.fill",
            stylers: [
              {
                color: "#ffffff",
              },
              {
                lightness: 17,
              },
            ],
          },
          {
            featureType: "road.highway",
            elementType: "geometry.stroke",
            stylers: [
              {
                color: "#ffffff",
              },
              {
                lightness: 29,
              },
              {
                weight: 0.2,
              },
            ],
          },
          {
            featureType: "road.arterial",
            elementType: "geometry",
            stylers: [
              {
                color: "#ffffff",
              },
              {
                lightness: 18,
              },
            ],
          },
          {
            featureType: "road.local",
            elementType: "geometry",
            stylers: [
              {
                color: "#ffffff",
              },
              {
                lightness: 16,
              },
            ],
          },
          {
            featureType: "poi",
            elementType: "geometry",
            stylers: [
              {
                color: "#f5f5f5",
              },
              {
                lightness: 21,
              },
            ],
          },
          {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [
              {
                color: "#dedede",
              },
              {
                lightness: 21,
              },
            ],
          },
          {
            elementType: "labels.text.stroke",
            stylers: [
              {
                visibility: "on",
              },
              {
                color: "#ffffff",
              },
              {
                lightness: 16,
              },
            ],
          },
          {
            elementType: "labels.text.fill",
            stylers: [
              {
                saturation: 36,
              },
              {
                color: "#333333",
              },
              {
                lightness: 40,
              },
            ],
          },
          {
            elementType: "labels.icon",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            featureType: "transit",
            elementType: "geometry",
            stylers: [
              {
                color: "#f2f2f2",
              },
              {
                lightness: 19,
              },
            ],
          },
          {
            featureType: "administrative",
            elementType: "geometry.fill",
            stylers: [
              {
                color: "#fefefe",
              },
              {
                lightness: 20,
              },
            ],
          },
          {
            featureType: "administrative",
            elementType: "geometry.stroke",
            stylers: [
              {
                color: "#fefefe",
              },
              {
                lightness: 17,
              },
              {
                weight: 1.2,
              },
            ],
          },
        ],
      },
    };
  },

  mounted() {
    this.locateGeoLocation();

    this.$refs.mapRef.$mapPromise.then((map) => {
      for (let i = 0; i < this.locationMarkers.length; i++) {
        this.markers[i] = new google.maps.Marker({
          position: this.locationMarkers[i].position,
          map,
          title: this.locationMarkers[i].title,
          icon: './havallogo.png',
        });

        this.infowindow[i] = new google.maps.InfoWindow({
          content:
            "<b>" +
            this.locationMarkers[i].title +
            "</b>" +
            "<br>" +
            this.locationMarkers[i].address +
            "<br>" +
            this.locationMarkers[i].number,
        });

        this.markers[i].addListener("click", () => {
          this.infowindow[i].open({
            anchor: this.markers[i],
            map,
            shouldFocus: true,
          });
        });
      }
    });
  },

  methods: {
    initMarker(loc) {
      this.existingPlace = loc;
    },
    openLoc(link) {
      window.open(link);
    },
    closeAll(){
      for (let i = 0; i < this.infowindow.length; i++){
        this.infowindow[i].close();
      }
    },

    locationMarked: function(i) {
      this.$refs.mapRef.$mapPromise.then((map) => {
        this.closeAll();
        this.selectedIndex = i;
        map.setCenter(this.markers[i].getPosition());
        this.infowindow[i].open({
            anchor: this.markers[i],
            map,
            shouldFocus: true,
          });
      })
    },
    locateGeoLocation: function () {
      navigator.geolocation.getCurrentPosition((res) => {
        this.center = {
          lat: res.coords.latitude,
          lng: res.coords.longitude,
        };
      });
    },
  },
};
</script>